<div class="cg-dialog">
  <h3 class="cg-dialog__header cg-dialog__header--modal">
    Reset password for {{ data.user.firstName }} {{ data.user.lastName }}
  </h3>

  <ng-container *ngIf="(resetPasswordView$ | async) === 'error'">
    <div class="cg-error-msg cg-margin-bottom-lg">
      <cigna-icon type="exclamation-circle"></cigna-icon>
      <span data-spa-service-error>Error resseting password for this user</span>
    </div>
  </ng-container>

  <ng-container
    *ngIf="
      (resetPasswordView$ | async) === 'edit' ||
      (resetPasswordView$ | async) === 'error'
    "
  >
    <div>
      <p class="cg-margin-bottom-lg">
        Are you sure you want to reset this users password?
      </p>
    </div>
    <div class="cg-button-group cg-margin-top-lg">
      <button
        [disabled]="impersonator$ | async"
        cignaButton="primary"
        data-test="cg-reset-btn"
        (click)="onReset()"
        [cignaTrackClicks]="[
          'trackEventOther',
          'Reset password',
          'ac-WC006-Reset Password'
        ]"
      >
        Yes, Reset Password
      </button>
      <button cignaButton="secondary" (click)="onClose()">Cancel</button>
    </div>
  </ng-container>

  <ng-container *ngIf="(resetPasswordView$ | async) === 'loading'">
    <div class="cg-media">
      <div class="cg-media__img">
        <div class="cg-spinner cg-spinner-small"></div>
      </div>
      <div class="cg-media__bd cg-margin-top-xs cg-margin-left-sm">
        Resetting password...
      </div>
    </div>
    <div class="cg-button-group cg-margin-top-lg">
      <button cignaButton="secondary" (click)="onClose()">Cancel</button>
    </div>
  </ng-container>

  <ng-container *ngIf="(resetPasswordView$ | async) === 'success'">
    <div class="cg-media">
      <div class="cg-media__img">
        <cigna-icon
          class="cg-icon-md cg-color-digital-green"
          type="check-circle"
        ></cigna-icon>
      </div>
      <div class="cg-media__bd cg-margin-top-sm">
        Password reset completed<br /><br />
        Temporary password:<br /><strong>{{
          resetPasswordResponse$ | async
        }}</strong>
      </div>
    </div>
    <div class="cg-button-group cg-margin-top-lg">
      <button cignaButton="secondary" (click)="onClose()">Close</button>
    </div>
  </ng-container>
</div>
